import { stopEvent } from '@aytm/lib/common/func'
import { fromEvent as ObservableFromEvent, merge as ObservableMerge } from 'rxjs'
import { map as rxMap, takeUntil as rxTakeUntil, take as rxTake, filter as rxFilter } from 'rxjs/operators'

const JITTER_SPACE = 3

export function processTouchEvent(event) {
  if (event.touches.length) {
    event.clientX = event.touches[0].clientX
    event.clientY = event.touches[0].clientY
  } else {
    event.clientX = event.changedTouches[0].clientX
    event.clientY = event.changedTouches[0].clientY
  }
  return event
}

function processResizeTouchEvent(event) {
  if (event.touches.length > 1) {
    event.hypot = Math.hypot(
      event.touches[0].pageX - event.touches[1].pageX,
      event.touches[0].pageY - event.touches[1].pageY
    )
  }
  return event
}

export default function drag(event, targetOffsetX, targetOffsetY) {
  const el = event.target.closest('body')
  const startX = event.clientX
  const startY = event.clientY

  const offsetX = targetOffsetX - startX
  const offsetY = targetOffsetY - startY

  const moves = ObservableMerge(
    ObservableFromEvent(el, 'mousemove'),
    ObservableFromEvent(el, 'touchmove', { passive: false }).pipe(rxMap(event => processTouchEvent(event)))
  )
  const ends = ObservableMerge(
    ObservableFromEvent(el, 'mouseup'),
    ObservableFromEvent(el, 'touchend', { passive: false }).pipe(rxMap(event => processTouchEvent(event)))
  )

  let dragHappened = false

  return ObservableMerge(
    moves.pipe(
      rxFilter(event => {
        if (dragHappened) {
          return true
        }
        const isMoved =
          Math.abs(startX - event.clientX) > JITTER_SPACE || Math.abs(startY - event.clientY) > JITTER_SPACE
        if (!dragHappened && isMoved) {
          dragHappened = true
        }
        return isMoved
      }),
      rxMap(event => {
        if (event.cancelable) {
          stopEvent(event)
        }
        return {
          x: event.clientX + offsetX,
          y: event.clientY + offsetY,
          dragging: true
        }
      }),
      rxTakeUntil(ends)
    ),
    ends.pipe(
      rxTake(1),
      rxMap(event => {
        if (event.cancelable) {
          stopEvent(event)
        }
        return {
          x: event.clientX + offsetX,
          y: event.clientY + offsetY,
          dragging: false
        }
      })
    )
  )
}

export function resize(event) {
  const eventHypot = event.hypot

  const touchMoves = ObservableFromEvent(document, 'touchmove', { passive: false }).pipe(
    rxMap(event => processResizeTouchEvent(event))
  )
  const touchEnd = ObservableFromEvent(document, 'touchend', { passive: false }).pipe(
    rxMap(event => processResizeTouchEvent(event))
  )

  return ObservableMerge(
    touchMoves.pipe(
      rxFilter(event => {
        if (2 !== event.touches.length) {
          return false
        }
        return true
      }),
      rxMap(event => {
        const eventHypot = event.hypot
        if (event.cancelable) {
          stopEvent(event)
        }
        return {
          hypot: eventHypot,
          scaling: true
        }
      }),
      rxTakeUntil(touchEnd)
    ),
    touchEnd.pipe(
      rxTake(1),
      rxMap(__event => {
        return {
          hypot: eventHypot,
          scaling: false
        }
      })
    )
  )
}
